import { Sizes } from "../constants/size";
import type { IconProps } from "../types/icon-props";

export const YoutubeColored = (props: IconProps) => {
  const {
    size = "md",
    fill = "var(--grey-1)",
    stroke = "var(--grey-1)",
    ...rest
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 33 32"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_9796_204)">
        <path
          d="M13.446 20.1798L13.445 11.125L22.091 15.668L13.446 20.1798ZM32.43 9.55595C32.43 9.55595 32.117 7.33531 31.158 6.35742C29.941 5.07338 28.577 5.06732 27.952 4.9928C23.474 4.6665 16.757 4.6665 16.757 4.6665H16.743C16.743 4.6665 10.026 4.6665 5.548 4.9928C4.922 5.06732 3.559 5.07338 2.341 6.35742C1.382 7.33531 1.07 9.55595 1.07 9.55595C1.07 9.55595 0.75 12.1643 0.75 14.7717V17.2169C0.75 19.8253 1.07 22.4327 1.07 22.4327C1.07 22.4327 1.382 24.6533 2.341 25.6312C3.559 26.9152 5.158 26.8749 5.87 27.0089C8.43 27.2566 16.75 27.3332 16.75 27.3332C16.75 27.3332 23.474 27.3231 27.952 26.9968C28.577 26.9213 29.941 26.9152 31.158 25.6312C32.117 24.6533 32.43 22.4327 32.43 22.4327C32.43 22.4327 32.75 19.8253 32.75 17.2169V14.7717C32.75 12.1643 32.43 9.55595 32.43 9.55595Z"
          fill="#CE1312"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_9796_204">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

YoutubeColored.displayName = "YoutubeColored";
